
import Game from "../../../assets/filled/Game.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GameIcon({ className, dataTestid = "GameIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Game data-testid={dataTestid} className={classes} {...rest} />
  );
}
